<script setup lang="ts">
type OptionType = string | { id: string; title: string }

const props = defineProps({
  options: { type: Array as PropType<OptionType[]>, required: true },
  name: { type: String, required: true },
  value: { type: String, default: '' },
  values: { type: Array<string>, default: [] },
  valuesTitle: { type: String, default: '' },
  placeholder: { type: String, required: true },
  checklist: { type: Boolean, default: false },
  searchBox: { type: Boolean, default: false },
  bottom: { type: Boolean, default: false },
  limit: { type: Number, default: 0 },
  label: { type: String, default: '' },
  addCustom: { type: Boolean, default: false }
})

const renderedOptions = ref(props.options)

watch(
  () => props.options,
  () => (renderedOptions.value = props.options)
)

const emit = defineEmits(['handleClick', 'handleReset'])

const clickOption = (option: OptionType) => {
  // if checklsit with limit
  if (
    props.checklist && // if there is a checklist
    props.limit > 0 && // if there is a limit
    props.values.length >= props.limit &&
    props.values.findIndex((v) => {
      return v === getId(option)
    }) < 0
  ) {
    alert(`Please limit your choices to ${props.limit}.`)
    return
  }

  // if not checklist, or if checklist no limit
  emit('handleClick', props.name, getId(option))
}

const clickReset = () => {
  emit('handleReset', props.name)
}

const getId = (option: OptionType) => {
  if (typeof option === 'string') return option
  else return option.id
}
</script>

<template>
  <div class="form-dropdown-outer-wrapper">
    <label v-if="label">{{ label }}</label>

    <FormSelectMultiple
      v-if="checklist"
      :options="options"
      :name="name"
      :values="values"
      :values-title="valuesTitle"
      :placeholder="placeholder"
      :add-custom="addCustom"
      :limit="limit"
      @click-reset="clickReset"
      @handle-click="clickOption"
    />

    <FormSelectSearch
      v-else-if="searchBox"
      :options="options"
      :name="name"
      :value="value"
      :placeholder="placeholder"
      @handle-click="clickOption"
    />

    <FormSelect
      v-else
      :options="options"
      :name="name"
      :value="value"
      :placeholder="placeholder"
      :search-box="searchBox"
      @handle-click="clickOption"
    />
  </div>
</template>

<style lang="scss" scoped>
.form-dropdown-outer-wrapper {
  :deep(.header) {
    position: relative;

    .header-chevron {
      position: absolute;
      top: 0;
      right: 0;
      height: 100%;
      width: 30px;
      user-select: none;
      pointer-events: none;
      display: flex;
      align-items: center;

      svg {
        $svgSize: 13px;
        height: $svgSize;
        width: $svgSize;
        transform: rotate(90deg);
        fill: var(--black);
        transition: transform 0.3s ease-out;
      }
    }
  }
}
</style>
